<div class="app-layout">
  <!-- Sidebar Component -->
  <app-sidebar-2 
    #sidebarRef 
    (sideBarToggled)="onSidebarToggled($event)"
    (mobileToggled)="isMobileSidebarOpen = $event">
  </app-sidebar-2>

  <!-- Top Navigation Header -->
  <header class="top-navbar" [ngClass]="{'navbar-collapsed': isSideBarCollapsed && !isMobileScreen, 'navbar-mobile': isMobileScreen}">
    <!-- Mobile Menu Group -->
    <div class="mobile-brand-group" *ngIf="isMobileScreen">
      <button 
        (click)="sidebarRef.toggleMobile()" 
        mat-icon-button 
        class="mobile-menu-trigger" 
        aria-label="Toggle navigation drawer">
        <mat-icon>menu</mat-icon>
      </button>

      <div class="brand-mobile">
        <span>Boxing Reflex Ball</span>
      </div>
    </div>


    <!-- User Profile & Dropdown -->
    <div class="profile-section">
      <div class="profile" [matMenuTriggerFor]="profilemenu">
        <img 
          *ngIf="!profileDetail?.imgUrl" 
          src="/assets/images/profile/user-1.jpg" 
          alt="Profile picture" 
          class="profile-img">
        <img 
          *ngIf="profileDetail?.imgUrl" 
          [src]="profileDetail?.imgUrl" 
          alt="Profile picture" 
          class="profile-img">
        
        <div class="profile-meta" *ngIf="!isMobileScreen">
          <p class="profile-name">{{ profileDetail?.fullName || 'Admin' }}</p>
          <p class="profile-email">{{ profileDetail?.email }}</p>
        </div>

        <mat-icon class="profile-dropdown-arrow">expand_more</mat-icon>
      </div>

      <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
        <button (click)="openProfileModel()" mat-menu-item>
          <mat-icon class="d-flex align-items-center"><i-tabler name="user" class="icon-18 d-flex"></i-tabler></mat-icon>
          My Profile
        </button>

        <button (click)="openUpdatePasswordModel()" mat-menu-item>
          <mat-icon class="d-flex align-items-center"><i-tabler name="edit" class="icon-18 d-flex"></i-tabler></mat-icon>
          Update Password
        </button>

        <mat-divider></mat-divider>

        <button (click)="logout()" mat-menu-item class="logout-menu-item">
          <mat-icon color="warn">logout</mat-icon>
          <span class="text-danger">Logout</span>
        </button>
      </mat-menu>
    </div>
  </header>

  <!-- Main View Route Container -->
  <main 
    class="page-content" 
    [ngClass]="{
      'content-collapsed': isSideBarCollapsed && !isMobileScreen, 
      'content-expanded': !isSideBarCollapsed && !isMobileScreen, 
      'content-mobile': isMobileScreen
    }">
    <router-outlet></router-outlet>
  </main>
</div>